import { render, staticRenderFns } from "./ChallengeLeaderboard.vue?vue&type=template&id=49e646cc&scoped=true&"
import script from "./ChallengeLeaderboard.vue?vue&type=script&lang=js&"
export * from "./ChallengeLeaderboard.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeLeaderboard.vue?vue&type=style&index=0&id=49e646cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e646cc",
  null
  
)

export default component.exports